'use client';

import { FlagExperiment } from 'src/data/FlagsApi/FlagsApi.type';
import { ABTestEventType } from 'src/general/helpers/CarmaTrackingApi.types';
import { pushCarmaEvent } from 'src/general/helpers/carmaCritical';
import { getGroupForExperiment } from 'src/general/helpers/flags/getGroupForExperiment';

/**
 * Send an AB test event
 * @param experiment - The experiment to track
 * @param type - The type of event to track
 */
export const sendABTestEvent = (experiment: FlagExperiment, type: ABTestEventType) => {
  const group = getGroupForExperiment(experiment);
  pushCarmaEvent({
    event: 'ab_test',
    metadata: {
      experiment_name: experiment.name,
      type,
      group,
    },
  });
};
